import { render, staticRenderFns } from "./RsaSchedaAachenerAphasieTestEditComponent.vue?vue&type=template&id=532b47ae"
import script from "./RsaSchedaAachenerAphasieTestEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaAachenerAphasieTestEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports